var _rect, _rect2, _g, _path, _path2, _path3, _rect3, _rect4, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect5, _rect6, _g3, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyHighlights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 275,
    viewBox: "0 0 535 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_185_6989)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5312,
    y: 24.9883,
    width: 193.613,
    height: 193.613,
    rx: 7.41749,
    fill: "url(#paint0_linear_185_6989)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_6989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 24,
    width: 195,
    height: 195
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5312,
    y: 24.9883,
    width: 193.613,
    height: 193.613,
    rx: 7.41749,
    fill: "#323232"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_6989)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9509 71.0336C66.4551 80.4997 47.0558 69.6346 38.811 86.7341C24.682 116.037 24.9384 130.56 14.2167 125.978C-0.494507 119.69 -12.2045 88.7668 -20.2395 74.9727C-28.4383 60.8974 -37.3551 51.5919 -34.0344 35.6001C-30.1764 17.0209 -10.8677 16.8578 2.35464 3.16982C16.5403 -11.5154 14.4475 -22.0155 34.8209 -23.0884C56.5726 -24.2338 117.06 -1.37872 137.186 6.6715C165.289 17.912 127.503 22.662 113.638 42.2551C102.976 57.3219 93.7522 67.8924 86.9509 71.0336Z",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.811 83.8913C333.293 115.711 322.467 113.691 332.552 129.774C341.776 144.485 270.016 247.616 265.433 258.338C259.146 273.049 269.336 286.888 255.542 294.923C241.467 303.122 232.161 312.039 216.169 308.718C197.59 304.86 197.427 285.552 183.739 272.329C169.054 258.144 145.657 248.571 144.584 228.197C143.439 206.446 181.217 203.296 199.98 192.44C218.742 181.584 206.379 156.043 217.848 133.475C229.317 110.906 288.25 78.4658 294.811 83.8913Z",
    fill: "#A2C166"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9571 153.979H78.8303L77.7776 156.969H75.2722L80.5147 142.315H83.2938L88.5363 156.969H86.0098L84.9571 153.979ZM84.2834 152.021L81.9043 145.22L79.5041 152.021H84.2834ZM93.616 147.326V153.747C93.616 154.183 93.7143 154.498 93.9108 154.695C94.1213 154.877 94.4722 154.969 94.9635 154.969H96.4373V156.969H94.5424C93.4616 156.969 92.6335 156.716 92.058 156.211C91.4825 155.705 91.1948 154.884 91.1948 153.747V147.326H89.8262V145.368H91.1948V142.483H93.616V145.368H96.4373V147.326H93.616ZM101.45 147.326V153.747C101.45 154.183 101.548 154.498 101.744 154.695C101.955 154.877 102.306 154.969 102.797 154.969H104.271V156.969H102.376C101.295 156.969 100.467 156.716 99.8916 156.211C99.3162 155.705 99.0284 154.884 99.0284 153.747V147.326H97.6599V145.368H99.0284V142.483H101.45V145.368H104.271V147.326H101.45ZM117.115 150.884C117.115 151.319 117.087 151.712 117.031 152.063H108.167C108.238 152.99 108.581 153.733 109.199 154.295C109.817 154.856 110.575 155.137 111.473 155.137C112.764 155.137 113.677 154.597 114.21 153.516H116.8C116.449 154.583 115.81 155.46 114.884 156.148C113.971 156.821 112.834 157.158 111.473 157.158C110.364 157.158 109.368 156.913 108.483 156.421C107.613 155.916 106.925 155.214 106.42 154.316C105.929 153.404 105.683 152.351 105.683 151.158C105.683 149.965 105.922 148.919 106.399 148.021C106.89 147.108 107.571 146.407 108.441 145.915C109.325 145.424 110.336 145.178 111.473 145.178C112.568 145.178 113.543 145.417 114.399 145.894C115.256 146.371 115.922 147.045 116.4 147.915C116.877 148.772 117.115 149.761 117.115 150.884ZM114.61 150.126C114.596 149.242 114.28 148.533 113.663 148C113.045 147.466 112.28 147.2 111.368 147.2C110.54 147.2 109.831 147.466 109.241 148C108.652 148.519 108.301 149.228 108.188 150.126H114.61ZM125.331 145.178C126.243 145.178 127.057 145.368 127.773 145.747C128.503 146.126 129.071 146.687 129.478 147.431C129.885 148.175 130.089 149.073 130.089 150.126V156.969H127.71V150.484C127.71 149.445 127.45 148.652 126.931 148.105C126.411 147.543 125.703 147.263 124.804 147.263C123.906 147.263 123.19 147.543 122.657 148.105C122.137 148.652 121.878 149.445 121.878 150.484V156.969H119.477V145.368H121.878V146.694C122.271 146.217 122.769 145.845 123.373 145.578C123.99 145.312 124.643 145.178 125.331 145.178ZM132.35 151.116C132.35 149.951 132.589 148.919 133.066 148.021C133.557 147.122 134.217 146.428 135.045 145.936C135.887 145.431 136.821 145.178 137.845 145.178C138.603 145.178 139.347 145.347 140.077 145.684C140.821 146.007 141.411 146.442 141.846 146.989V141.389H144.267V156.969H141.846V155.221C141.453 155.783 140.905 156.246 140.204 156.611C139.516 156.976 138.723 157.158 137.824 157.158C136.814 157.158 135.887 156.906 135.045 156.4C134.217 155.881 133.557 155.165 133.066 154.253C132.589 153.326 132.35 152.281 132.35 151.116ZM141.846 151.158C141.846 150.358 141.677 149.663 141.34 149.073C141.018 148.484 140.59 148.035 140.056 147.726C139.523 147.417 138.947 147.263 138.33 147.263C137.712 147.263 137.137 147.417 136.603 147.726C136.07 148.021 135.635 148.463 135.298 149.052C134.975 149.628 134.814 150.316 134.814 151.116C134.814 151.916 134.975 152.618 135.298 153.221C135.635 153.825 136.07 154.288 136.603 154.611C137.151 154.919 137.726 155.074 138.33 155.074C138.947 155.074 139.523 154.919 140.056 154.611C140.59 154.302 141.018 153.853 141.34 153.263C141.677 152.66 141.846 151.958 141.846 151.158ZM158.052 150.884C158.052 151.319 158.024 151.712 157.968 152.063H149.104C149.174 152.99 149.518 153.733 150.136 154.295C150.753 154.856 151.511 155.137 152.409 155.137C153.701 155.137 154.613 154.597 155.146 153.516H157.736C157.385 154.583 156.747 155.46 155.82 156.148C154.908 156.821 153.771 157.158 152.409 157.158C151.301 157.158 150.304 156.913 149.42 156.421C148.549 155.916 147.862 155.214 147.356 154.316C146.865 153.404 146.62 152.351 146.62 151.158C146.62 149.965 146.858 148.919 147.335 148.021C147.827 147.108 148.507 146.407 149.378 145.915C150.262 145.424 151.272 145.178 152.409 145.178C153.504 145.178 154.48 145.417 155.336 145.894C156.192 146.371 156.859 147.045 157.336 147.915C157.813 148.772 158.052 149.761 158.052 150.884ZM155.546 150.126C155.532 149.242 155.217 148.533 154.599 148C153.981 147.466 153.216 147.2 152.304 147.2C151.476 147.2 150.767 147.466 150.178 148C149.588 148.519 149.237 149.228 149.125 150.126H155.546ZM171.046 150.884C171.046 151.319 171.018 151.712 170.962 152.063H162.098C162.168 152.99 162.512 153.733 163.13 154.295C163.748 154.856 164.506 155.137 165.404 155.137C166.695 155.137 167.607 154.597 168.141 153.516H170.731C170.38 154.583 169.741 155.46 168.815 156.148C167.902 156.821 166.765 157.158 165.404 157.158C164.295 157.158 163.298 156.913 162.414 156.421C161.544 155.916 160.856 155.214 160.351 154.316C159.86 153.404 159.614 152.351 159.614 151.158C159.614 149.965 159.853 148.919 160.33 148.021C160.821 147.108 161.502 146.407 162.372 145.915C163.256 145.424 164.267 145.178 165.404 145.178C166.499 145.178 167.474 145.417 168.33 145.894C169.187 146.371 169.853 147.045 170.331 147.915C170.808 148.772 171.046 149.761 171.046 150.884ZM168.541 150.126C168.527 149.242 168.211 148.533 167.593 148C166.976 147.466 166.211 147.2 165.299 147.2C164.47 147.2 163.762 147.466 163.172 148C162.583 148.519 162.232 149.228 162.119 150.126H168.541ZM177.619 157.158C176.707 157.158 175.886 156.997 175.156 156.674C174.44 156.337 173.872 155.888 173.45 155.327C173.029 154.751 172.805 154.112 172.777 153.411H175.261C175.303 153.902 175.535 154.316 175.956 154.653C176.391 154.976 176.931 155.137 177.577 155.137C178.251 155.137 178.77 155.011 179.135 154.758C179.514 154.491 179.704 154.155 179.704 153.747C179.704 153.312 179.493 152.99 179.072 152.779C178.665 152.568 178.012 152.337 177.114 152.084C176.244 151.846 175.535 151.614 174.987 151.389C174.44 151.165 173.963 150.821 173.556 150.358C173.163 149.895 172.966 149.284 172.966 148.526C172.966 147.908 173.149 147.347 173.514 146.842C173.879 146.322 174.398 145.915 175.072 145.621C175.759 145.326 176.545 145.178 177.43 145.178C178.749 145.178 179.809 145.515 180.609 146.189C181.423 146.849 181.858 147.754 181.914 148.905H179.514C179.472 148.386 179.261 147.972 178.882 147.663C178.503 147.354 177.991 147.2 177.346 147.2C176.714 147.2 176.23 147.319 175.893 147.558C175.556 147.796 175.387 148.112 175.387 148.505C175.387 148.814 175.5 149.073 175.724 149.284C175.949 149.495 176.223 149.663 176.545 149.789C176.868 149.902 177.346 150.049 177.977 150.231C178.819 150.456 179.507 150.688 180.04 150.926C180.588 151.151 181.058 151.488 181.451 151.937C181.844 152.386 182.048 152.982 182.062 153.726C182.062 154.386 181.879 154.976 181.514 155.495C181.149 156.014 180.63 156.421 179.956 156.716C179.297 157.011 178.518 157.158 177.619 157.158Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.432 124.273V120C146.432 117.733 145.531 115.559 143.928 113.956C142.325 112.354 140.152 111.453 137.885 111.453H120.791C118.524 111.453 116.35 112.354 114.747 113.956C113.145 115.559 112.244 117.733 112.244 120V124.273",
    stroke: "white",
    strokeWidth: 2.4725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.338 102.91C134.058 102.91 137.885 99.0836 137.885 94.3633C137.885 89.643 134.058 85.8164 129.338 85.8164C124.618 85.8164 120.791 89.643 120.791 94.3633C120.791 99.0836 124.618 102.91 129.338 102.91Z",
    stroke: "white",
    strokeWidth: 2.4725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_185_6989)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 310.745,
    y: 25.0664,
    width: 192.476,
    height: 192.476,
    rx: 7.65695,
    fill: "url(#paint1_linear_185_6989)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_185_6989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 310,
    y: 25,
    width: 194,
    height: 193
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 310.745,
    y: 25.0664,
    width: 192.476,
    height: 192.476,
    rx: 7.65695,
    fill: "#323232"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_185_6989)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.475 209.452C321.176 195.578 334.864 193.276 353.723 192.588C370.973 191.959 378.725 213.387 385.678 222.662C395.218 235.387 412.198 233.493 412.259 249.363C412.321 265.556 415.373 278 404.565 290.117C392.009 304.195 375.304 294.738 357.116 299.95C337.604 305.542 334.186 315.622 316.113 306.419C296.817 296.593 298.317 285.528 298.297 263.978C298.277 242.321 297.152 221.819 308.475 209.452Z",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.411 -61.3299C477.348 -66.9943 490.353 -62.1443 507.03 -53.3103C522.283 -45.2302 518.282 -22.7966 519.666 -11.2881C521.565 4.50262 537.218 11.3523 529.336 25.1264C521.293 39.1813 517.714 51.4836 502.295 56.5737C484.382 62.4872 474.644 45.9446 456.287 41.3648C436.593 36.4513 428.593 43.4723 417.543 26.4654C405.744 8.3079 412.577 -0.524873 423.334 -19.1972C434.145 -37.9631 443.422 -56.2803 459.411 -61.3299Z",
    fill: "#4AC1C0"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.468 72.9219V83.326",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M406.468 114.535V124.939",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.079 80.543L395.44 87.9039",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M417.495 109.949L424.856 117.31",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.459 98.9375H390.863",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422.073 98.9375H432.477",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M388.079 117.31L395.44 109.949",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M417.495 87.9039L424.856 80.543",
    stroke: "white",
    strokeWidth: 2.55232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.465 89.4844L409.388 95.399L415.923 96.3533L411.194 100.955L412.31 107.455L406.465 104.384L400.62 107.455L401.736 100.955L397.007 96.3533L403.542 95.399L406.465 89.4844Z",
    stroke: "white",
    strokeWidth: 2.55232
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M349.419 143.695V147.99H354.472V149.948H349.419V154.433H355.104V156.391H347.019V141.737H355.104V143.695H349.419ZM362.545 154.243L365.829 144.79H368.377L363.955 156.391H361.092L356.692 144.79H359.26L362.545 154.243ZM380.823 150.306C380.823 150.741 380.795 151.134 380.739 151.485H371.875C371.945 152.411 372.289 153.155 372.907 153.717C373.524 154.278 374.282 154.559 375.181 154.559C376.472 154.559 377.384 154.019 377.918 152.938H380.507C380.157 154.004 379.518 154.882 378.592 155.57C377.679 156.243 376.542 156.58 375.181 156.58C374.072 156.58 373.075 156.334 372.191 155.843C371.321 155.338 370.633 154.636 370.128 153.738C369.636 152.825 369.391 151.773 369.391 150.58C369.391 149.387 369.629 148.341 370.107 147.443C370.598 146.53 371.279 145.828 372.149 145.337C373.033 144.846 374.044 144.6 375.181 144.6C376.276 144.6 377.251 144.839 378.107 145.316C378.963 145.793 379.63 146.467 380.107 147.337C380.585 148.194 380.823 149.183 380.823 150.306ZM378.318 149.548C378.304 148.664 377.988 147.955 377.37 147.422C376.753 146.888 375.988 146.621 375.075 146.621C374.247 146.621 373.539 146.888 372.949 147.422C372.359 147.941 372.009 148.65 371.896 149.548H378.318ZM389.038 144.6C389.951 144.6 390.765 144.79 391.481 145.169C392.211 145.548 392.779 146.109 393.186 146.853C393.593 147.597 393.797 148.495 393.797 149.548V156.391H391.417V149.906C391.417 148.867 391.158 148.074 390.638 147.527C390.119 146.965 389.41 146.685 388.512 146.685C387.614 146.685 386.898 146.965 386.364 147.527C385.845 148.074 385.585 148.867 385.585 149.906V156.391H383.185V144.79H385.585V146.116C385.978 145.639 386.477 145.267 387.08 145C387.698 144.734 388.351 144.6 389.038 144.6ZM399.658 146.748V153.169C399.658 153.604 399.757 153.92 399.953 154.117C400.164 154.299 400.515 154.39 401.006 154.39H402.48V156.391H400.585C399.504 156.391 398.676 156.138 398.1 155.633C397.525 155.127 397.237 154.306 397.237 153.169V146.748H395.869V144.79H397.237V141.905H399.658V144.79H402.48V146.748H399.658ZM408.903 156.58C407.99 156.58 407.169 156.419 406.439 156.096C405.723 155.759 405.155 155.31 404.734 154.748C404.313 154.173 404.088 153.534 404.06 152.832H406.545C406.587 153.324 406.818 153.738 407.239 154.075C407.675 154.397 408.215 154.559 408.861 154.559C409.534 154.559 410.054 154.433 410.419 154.18C410.798 153.913 410.987 153.576 410.987 153.169C410.987 152.734 410.777 152.411 410.355 152.201C409.948 151.99 409.296 151.759 408.397 151.506C407.527 151.267 406.818 151.036 406.271 150.811C405.723 150.587 405.246 150.243 404.839 149.78C404.446 149.316 404.25 148.706 404.25 147.948C404.25 147.33 404.432 146.769 404.797 146.264C405.162 145.744 405.681 145.337 406.355 145.042C407.043 144.748 407.829 144.6 408.713 144.6C410.033 144.6 411.092 144.937 411.892 145.611C412.706 146.271 413.142 147.176 413.198 148.327H410.798C410.755 147.808 410.545 147.393 410.166 147.085C409.787 146.776 409.275 146.621 408.629 146.621C407.997 146.621 407.513 146.741 407.176 146.979C406.839 147.218 406.671 147.534 406.671 147.927C406.671 148.236 406.783 148.495 407.008 148.706C407.232 148.916 407.506 149.085 407.829 149.211C408.152 149.323 408.629 149.471 409.261 149.653C410.103 149.878 410.791 150.109 411.324 150.348C411.871 150.573 412.342 150.91 412.735 151.359C413.128 151.808 413.331 152.404 413.345 153.148C413.345 153.808 413.163 154.397 412.798 154.917C412.433 155.436 411.913 155.843 411.24 156.138C410.58 156.433 409.801 156.58 408.903 156.58ZM433.093 141.758V156.391H430.693V149.99H423.808V156.391H421.408V141.758H423.808V148.032H430.693V141.758H433.093ZM446.885 150.306C446.885 150.741 446.857 151.134 446.801 151.485H437.937C438.007 152.411 438.351 153.155 438.969 153.717C439.586 154.278 440.344 154.559 441.242 154.559C442.534 154.559 443.446 154.019 443.98 152.938H446.569C446.218 154.004 445.58 154.882 444.653 155.57C443.741 156.243 442.604 156.58 441.242 156.58C440.134 156.58 439.137 156.334 438.253 155.843C437.383 155.338 436.695 154.636 436.189 153.738C435.698 152.825 435.453 151.773 435.453 150.58C435.453 149.387 435.691 148.341 436.168 147.443C436.66 146.53 437.34 145.828 438.211 145.337C439.095 144.846 440.106 144.6 441.242 144.6C442.337 144.6 443.313 144.839 444.169 145.316C445.025 145.793 445.692 146.467 446.169 147.337C446.646 148.194 446.885 149.183 446.885 150.306ZM444.38 149.548C444.365 148.664 444.05 147.955 443.432 147.422C442.815 146.888 442.05 146.621 441.137 146.621C440.309 146.621 439.6 146.888 439.011 147.422C438.421 147.941 438.07 148.65 437.958 149.548H444.38ZM451.647 140.811V156.391H449.247V140.811H451.647ZM453.998 150.538C453.998 149.373 454.237 148.341 454.714 147.443C455.205 146.544 455.865 145.849 456.693 145.358C457.535 144.853 458.469 144.6 459.494 144.6C460.251 144.6 460.995 144.769 461.725 145.106C462.469 145.428 463.059 145.864 463.494 146.411V140.811H465.915V156.391H463.494V154.643C463.101 155.205 462.553 155.668 461.852 156.033C461.164 156.398 460.371 156.58 459.472 156.58C458.462 156.58 457.535 156.327 456.693 155.822C455.865 155.303 455.205 154.587 454.714 153.675C454.237 152.748 453.998 151.703 453.998 150.538ZM463.494 150.58C463.494 149.78 463.325 149.085 462.989 148.495C462.666 147.906 462.238 147.457 461.704 147.148C461.171 146.839 460.595 146.685 459.978 146.685C459.36 146.685 458.785 146.839 458.251 147.148C457.718 147.443 457.283 147.885 456.946 148.474C456.623 149.05 456.462 149.737 456.462 150.538C456.462 151.338 456.623 152.039 456.946 152.643C457.283 153.247 457.718 153.71 458.251 154.033C458.799 154.341 459.374 154.496 459.978 154.496C460.595 154.496 461.171 154.341 461.704 154.033C462.238 153.724 462.666 153.275 462.989 152.685C463.325 152.082 463.494 151.38 463.494 150.58Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_185_6989)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 168.034,
    y: 16.418,
    width: 201.039,
    height: 210.997,
    rx: 7.89533,
    fill: "url(#paint2_linear_185_6989)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_185_6989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 16,
    width: 202,
    height: 212
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168.034,
    y: 16.418,
    width: 201.039,
    height: 210.997,
    rx: 7.89533,
    fill: "#323232"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_185_6989)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.445 -27.8257C346.009 -38.9125 360.442 -37.4669 379.655 -32.8443C397.228 -28.6163 399.256 -3.72681 403.764 8.06653C409.949 24.2481 427.592 27.06 423.363 43.8814C419.049 61.0457 418.763 75.0878 404.584 84.8522C388.11 96.1963 395.718 116.885 379.655 104.805C357.663 88.2673 329.941 88.3134 314.195 73.4405C297.383 57.5615 304.436 50.0585 304.436 27.0235C304.437 3.28219 314.678 -17.9422 329.445 -27.8257Z",
    fill: "#9C6EBA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_185_6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.446 164.356C117.145 147.623 134.433 144.846 158.325 144.016C180.178 143.258 190.631 169.102 199.717 180.288C212.185 195.637 224.44 195.793 234.199 212.493C244.5 230.12 238.982 247.032 225.632 261.646C210.122 278.626 188.666 267.219 165.759 273.506C141.182 280.25 137.143 292.408 113.959 281.308C89.2066 269.457 90.7867 256.111 90.1326 230.12C89.4753 203.999 87.4514 179.273 101.446 164.356Z",
    fill: "#F1CD60"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.109 95.3242L265.851 96.9857",
    stroke: "white",
    strokeWidth: 1.92432,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.069 98.332L270.811 99.9935",
    stroke: "white",
    strokeWidth: 1.92432,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.751 101.168L275.493 102.829",
    stroke: "white",
    strokeWidth: 1.92432,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.666 79.1802C271.989 78.7759 271.123 79.0182 270.731 79.7215L263.157 93.3076C263.221 93.4378 263.272 93.5758 263.309 93.7195C263.446 94.2546 263.372 94.8254 263.103 95.3064C262.835 95.7874 262.395 96.1392 261.879 96.2843C261.74 96.3232 261.6 96.3464 261.459 96.3542L250.778 115.515C250.386 116.218 250.617 117.116 251.294 117.521L254.507 119.439C254.729 119.122 255.082 118.948 255.446 118.949C255.649 118.949 255.856 119.004 256.046 119.119L259.221 121.044C259.411 121.159 259.56 121.319 259.662 121.504C259.839 121.823 259.876 122.214 259.742 122.566L262.742 124.357C263.419 124.761 264.285 124.519 264.677 123.816L274.654 105.919L275.291 104.776C275.217 104.634 275.159 104.482 275.118 104.323C274.981 103.788 275.055 103.218 275.323 102.737C275.592 102.256 276.032 101.904 276.548 101.759C276.701 101.716 276.857 101.692 277.013 101.687L284.63 88.0221C285.022 87.3188 284.791 86.4209 284.114 86.0166L272.666 79.1802ZM269.096 78.7454C270.011 77.1044 272.033 76.5389 273.613 77.4823L285.061 84.3188C286.64 85.2621 287.179 87.3572 286.265 88.9982L278.289 103.306L277.566 102.867L277.564 102.87C277.084 102.588 276.471 102.761 276.193 103.26C275.914 103.761 276.077 104.4 276.558 104.687L276.563 104.69L276.559 104.698L277.272 105.13L276.288 106.895L266.312 124.792C265.397 126.433 263.375 126.998 261.795 126.055L257.938 123.751L258.873 122.051L255.384 119.937L254.436 121.66L250.347 119.218C248.768 118.275 248.229 116.18 249.143 114.539L260.167 94.7641L260.854 95.1753L260.855 95.172L260.859 95.1742C261.34 95.4613 261.955 95.2881 262.235 94.7874C262.514 94.2866 262.351 93.648 261.871 93.3609L261.865 93.3578L261.867 93.3549L261.181 92.9443L269.096 78.7454Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.435 143.824V145.782H212.54V158.457H210.139V145.782H206.223V143.824H216.435ZM220.086 145.319C219.651 145.319 219.286 145.172 218.992 144.877C218.697 144.582 218.55 144.217 218.55 143.782C218.55 143.347 218.697 142.982 218.992 142.687C219.286 142.393 219.651 142.245 220.086 142.245C220.508 142.245 220.865 142.393 221.16 142.687C221.455 142.982 221.602 143.347 221.602 143.782C221.602 144.217 221.455 144.582 221.16 144.877C220.865 145.172 220.508 145.319 220.086 145.319ZM221.266 146.856V158.457H218.865V146.856H221.266ZM223.617 152.646C223.617 151.453 223.855 150.407 224.333 149.509C224.824 148.597 225.498 147.895 226.354 147.404C227.21 146.912 228.192 146.667 229.301 146.667C230.705 146.667 231.863 147.004 232.775 147.677C233.702 148.337 234.326 149.284 234.649 150.52H232.059C231.849 149.944 231.512 149.495 231.049 149.172C230.586 148.849 230.003 148.688 229.301 148.688C228.319 148.688 227.533 149.039 226.943 149.741C226.368 150.428 226.08 151.397 226.08 152.646C226.08 153.895 226.368 154.871 226.943 155.573C227.533 156.274 228.319 156.625 229.301 156.625C230.691 156.625 231.61 156.015 232.059 154.794H234.649C234.312 155.973 233.681 156.913 232.754 157.615C231.828 158.303 230.677 158.647 229.301 158.647C228.192 158.647 227.21 158.401 226.354 157.91C225.498 157.404 224.824 156.703 224.333 155.804C223.855 154.892 223.617 153.839 223.617 152.646ZM241.631 152.667L246.979 158.457H243.736L239.441 153.467V158.457H237.041V142.877H239.441V151.93L243.652 146.856H246.979L241.631 152.667ZM259.331 152.372C259.331 152.807 259.303 153.2 259.247 153.551H250.383C250.454 154.478 250.797 155.222 251.415 155.783C252.033 156.345 252.791 156.625 253.689 156.625C254.98 156.625 255.893 156.085 256.426 155.004H259.016C258.665 156.071 258.026 156.948 257.1 157.636C256.187 158.31 255.05 158.647 253.689 158.647C252.58 158.647 251.583 158.401 250.699 157.91C249.829 157.404 249.141 156.703 248.636 155.804C248.145 154.892 247.899 153.839 247.899 152.646C247.899 151.453 248.138 150.407 248.615 149.509C249.106 148.597 249.787 147.895 250.657 147.404C251.541 146.912 252.552 146.667 253.689 146.667C254.784 146.667 255.759 146.905 256.615 147.383C257.472 147.86 258.138 148.533 258.616 149.404C259.093 150.26 259.331 151.249 259.331 152.372ZM256.826 151.614C256.812 150.73 256.496 150.021 255.878 149.488C255.261 148.955 254.496 148.688 253.584 148.688C252.755 148.688 252.047 148.955 251.457 149.488C250.868 150.007 250.517 150.716 250.404 151.614H256.826ZM264.494 148.814V155.236C264.494 155.671 264.592 155.987 264.788 156.183C264.999 156.366 265.35 156.457 265.841 156.457H267.315V158.457H265.42C264.339 158.457 263.511 158.204 262.936 157.699C262.36 157.194 262.072 156.373 262.072 155.236V148.814H260.704V146.856H262.072V143.972H264.494V146.856H267.315V148.814H264.494ZM273.738 158.647C272.826 158.647 272.004 158.485 271.275 158.162C270.559 157.825 269.99 157.376 269.569 156.815C269.148 156.239 268.923 155.601 268.895 154.899H271.38C271.422 155.39 271.654 155.804 272.075 156.141C272.51 156.464 273.05 156.625 273.696 156.625C274.37 156.625 274.889 156.499 275.254 156.246C275.633 155.98 275.822 155.643 275.822 155.236C275.822 154.801 275.612 154.478 275.191 154.267C274.784 154.057 274.131 153.825 273.233 153.572C272.362 153.334 271.654 153.102 271.106 152.878C270.559 152.653 270.081 152.309 269.674 151.846C269.281 151.383 269.085 150.772 269.085 150.014C269.085 149.397 269.267 148.835 269.632 148.33C269.997 147.811 270.517 147.404 271.19 147.109C271.878 146.814 272.664 146.667 273.548 146.667C274.868 146.667 275.928 147.004 276.728 147.677C277.542 148.337 277.977 149.242 278.033 150.393H275.633C275.591 149.874 275.38 149.46 275.001 149.151C274.622 148.842 274.11 148.688 273.464 148.688C272.833 148.688 272.348 148.807 272.011 149.046C271.675 149.284 271.506 149.6 271.506 149.993C271.506 150.302 271.618 150.562 271.843 150.772C272.068 150.983 272.341 151.151 272.664 151.278C272.987 151.39 273.464 151.537 274.096 151.72C274.938 151.944 275.626 152.176 276.159 152.414C276.707 152.639 277.177 152.976 277.57 153.425C277.963 153.874 278.166 154.471 278.18 155.215C278.18 155.874 277.998 156.464 277.633 156.983C277.268 157.503 276.749 157.91 276.075 158.204C275.415 158.499 274.636 158.647 273.738 158.647ZM291.064 158.604C290.082 158.604 289.198 158.436 288.412 158.099C287.626 157.748 287.008 157.257 286.559 156.625C286.11 155.994 285.885 155.257 285.885 154.415H288.454C288.51 155.046 288.755 155.566 289.191 155.973C289.64 156.38 290.264 156.583 291.064 156.583C291.892 156.583 292.538 156.387 293.001 155.994C293.465 155.587 293.696 155.067 293.696 154.436C293.696 153.944 293.549 153.544 293.254 153.236C292.973 152.927 292.615 152.688 292.18 152.52C291.759 152.351 291.17 152.169 290.412 151.972C289.457 151.72 288.678 151.467 288.075 151.214C287.485 150.948 286.98 150.541 286.559 149.993C286.138 149.446 285.927 148.716 285.927 147.804C285.927 146.961 286.138 146.225 286.559 145.593C286.98 144.961 287.569 144.477 288.327 144.14C289.085 143.803 289.963 143.635 290.959 143.635C292.377 143.635 293.535 143.993 294.433 144.709C295.345 145.41 295.851 146.379 295.949 147.614H293.296C293.254 147.081 293.001 146.625 292.538 146.246C292.075 145.867 291.464 145.677 290.706 145.677C290.019 145.677 289.457 145.853 289.022 146.203C288.587 146.554 288.369 147.06 288.369 147.719C288.369 148.169 288.503 148.54 288.769 148.835C289.05 149.116 289.401 149.341 289.822 149.509C290.243 149.677 290.819 149.86 291.549 150.056C292.517 150.323 293.303 150.59 293.907 150.856C294.524 151.123 295.044 151.537 295.465 152.099C295.9 152.646 296.117 153.383 296.117 154.309C296.117 155.053 295.914 155.755 295.507 156.415C295.114 157.074 294.531 157.608 293.759 158.015C293.001 158.408 292.103 158.604 291.064 158.604ZM303.981 158.647C302.887 158.647 301.897 158.401 301.013 157.91C300.129 157.404 299.434 156.703 298.928 155.804C298.423 154.892 298.17 153.839 298.17 152.646C298.17 151.467 298.43 150.421 298.949 149.509C299.469 148.597 300.178 147.895 301.076 147.404C301.974 146.912 302.978 146.667 304.087 146.667C305.196 146.667 306.199 146.912 307.097 147.404C307.996 147.895 308.705 148.597 309.224 149.509C309.743 150.421 310.003 151.467 310.003 152.646C310.003 153.825 309.736 154.871 309.203 155.783C308.67 156.695 307.94 157.404 307.013 157.91C306.101 158.401 305.09 158.647 303.981 158.647ZM303.981 156.562C304.599 156.562 305.175 156.415 305.708 156.12C306.255 155.825 306.697 155.383 307.034 154.794C307.371 154.204 307.54 153.488 307.54 152.646C307.54 151.804 307.378 151.095 307.055 150.52C306.733 149.93 306.304 149.488 305.771 149.193C305.238 148.898 304.662 148.751 304.045 148.751C303.427 148.751 302.852 148.898 302.318 149.193C301.799 149.488 301.385 149.93 301.076 150.52C300.767 151.095 300.613 151.804 300.613 152.646C300.613 153.895 300.929 154.864 301.56 155.552C302.206 156.225 303.013 156.562 303.981 156.562ZM314.776 142.877V158.457H312.376V142.877H314.776ZM317.127 152.604C317.127 151.439 317.366 150.407 317.843 149.509C318.334 148.611 318.994 147.916 319.822 147.425C320.664 146.919 321.598 146.667 322.622 146.667C323.38 146.667 324.124 146.835 324.854 147.172C325.598 147.495 326.187 147.93 326.622 148.477V142.877H329.044V158.457H326.622V156.71C326.229 157.271 325.682 157.734 324.98 158.099C324.292 158.464 323.499 158.647 322.601 158.647C321.591 158.647 320.664 158.394 319.822 157.889C318.994 157.369 318.334 156.653 317.843 155.741C317.366 154.815 317.127 153.769 317.127 152.604ZM326.622 152.646C326.622 151.846 326.454 151.151 326.117 150.562C325.794 149.972 325.366 149.523 324.833 149.214C324.299 148.905 323.724 148.751 323.106 148.751C322.489 148.751 321.913 148.905 321.38 149.214C320.847 149.509 320.411 149.951 320.075 150.541C319.752 151.116 319.59 151.804 319.59 152.604C319.59 153.404 319.752 154.106 320.075 154.709C320.411 155.313 320.847 155.776 321.38 156.099C321.927 156.408 322.503 156.562 323.106 156.562C323.724 156.562 324.299 156.408 324.833 156.099C325.366 155.79 325.794 155.341 326.117 154.751C326.454 154.148 326.622 153.446 326.622 152.646Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_185_6989",
    x: 0.949923,
    y: 9.37291,
    width: 256.776,
    height: 256.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_185_6989",
    x: -108.34,
    y: -81.6685,
    width: 329.255,
    height: 297.123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.7963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.69024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_185_6989",
    x: 70.966,
    y: 24.7495,
    width: 335.996,
    height: 373.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.7963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.69024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_185_6989",
    x: 279.164,
    y: 9.45103,
    width: 255.638,
    height: 255.639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_185_6989",
    x: 222.289,
    y: 132.145,
    width: 266.382,
    height: 269.503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.9842
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.90623
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_185_6989",
    x: 335.385,
    y: -124.195,
    width: 272.123,
    height: 273.539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.9842
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.90623
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_185_6989",
    x: 136.453,
    y: 0.802593,
    width: 264.202,
    height: 274.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_185_6989",
    x: 224.634,
    y: -98.6155,
    width: 277.71,
    height: 301.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.0228
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.1668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.12123
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.4622
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_185_6989",
    x: 11.3061,
    y: 81.6892,
    width: 306.574,
    height: 298.464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.0228
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.1668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.12123
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.4622
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_6989",
    result: "effect2_dropShadow_185_6989"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_6989",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_6989",
    x1: 129.338,
    y1: 24.9883,
    x2: 129.113,
    y2: 236.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_6989",
    x1: 406.983,
    y1: 25.0664,
    x2: 406.76,
    y2: 235.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_185_6989",
    x1: 268.554,
    y1: 16.418,
    x2: 268.297,
    y2: 247.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHighlights);
export default __webpack_public_path__ + "static/media/emptyHighlights.ccdb1444cdfdfe667dd7fdc147a8be84.svg";
export { ForwardRef as ReactComponent };